import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-mizizi-charcoal text-mizizi-cream/80 mt-16 md:mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 py-10 md:py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
        <div>
          <div className="font-serif text-3xl text-mizizi-cream">MIZIZI</div>
          <p className="mt-3 text-sm leading-relaxed text-mizizi-cream/60">
            Thirty plant-based recipes inspired by the flavors of home kitchens, roadside markets, and slow Sunday tables across Africa.
          </p>
        </div>
        <div>
          <div className="overline text-mizizi-gold mb-4">The Book</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/philosophy" className="hover:text-mizizi-gold">Philosophy</Link></li>
            <li><Link to="/pantry" className="hover:text-mizizi-gold">Pantry & Ingredients</Link></li>
            <li><Link to="/preview" className="hover:text-mizizi-gold">Recipes</Link></li>
            <li><Link to="/shop" className="hover:text-mizizi-gold">Shop</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-mizizi-gold mb-4">Support</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/faq" className="hover:text-mizizi-gold">FAQ & Refund Policy</Link></li>
            <li><Link to="/privacy" className="hover:text-mizizi-gold">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-mizizi-gold">Terms of Use</Link></li>
            <li><a href="mailto:hello@mizizitable.com" className="hover:text-mizizi-gold">hello@mizizitable.com</a></li>
          </ul>
        </div>
        <div>
          <div className="overline text-mizizi-gold mb-4">Disclaimer</div>
          <p className="text-xs leading-relaxed text-mizizi-cream/50">
            All Mizizi recipes are 100% plant-based. Substitutions are suggestions — please assess your own allergies and dietary needs. Nothing on this site is medical or nutritional advice. © Mizizi 2026.
          </p>
        </div>
      </div>
    </footer>
  );
}
